import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './About.scss';

const About = () => {
  const { t } = useTranslation();
  const videoRefs = useRef([]);

  const handlePlay = (index) => {
    videoRefs.current.forEach((ref, i) => {
      if (i !== index && ref) {
        ref.pause();
      }
    });
  };

  return (
    <section className="about" id="about">
      <h2>{t('about.title')}</h2>
      <div className="content">
        <div className="text-container"> 
          <h6>{t('about.experience')}</h6>
          <p>{t('about.description')}</p>
        </div>
        <div className="video-container">
          <video
            ref={(ref) => (videoRefs.current[0] = ref)}
            controls
            controlsList="nodownload"
            onPlay={() => handlePlay(0)}
            width="850px"
            height="500px"
          >
            <source
              src="https://duavillage.s3.eu-north-1.amazonaws.com/dua-village-video.mp4"
              type="video/mp4"
            />
            {/* Fallback text for unsupported browsers */}
            {t('video.notSupported')}
          </video>
        </div>
      </div>
    </section>
  );
};

export default About;
